(() => {
  if (window.KiiveRefreshReviews) { window.KiiveRefreshReviews.init(document); return; }
  const states = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function destroy(root) { const state = states.get(root); if (state) { state.abort.abort(); clearTimeout(state.timer); states.delete(root); } }
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-refresh-reviews]')];
    if (scope.matches?.('[data-refresh-reviews]')) roots.unshift(scope);
    roots.forEach(root => {
      if (states.has(root)) return;
      const slides = [...root.querySelectorAll('[data-kp-review]')];
      const pause = root.querySelector('[data-kp-pause]');
      const count = root.querySelector('[data-kp-review-count]');
      const status = root.querySelector('[data-kp-review-status]');
      const state = { index:0, paused:reduced.matches || root.dataset.autoplay !== 'true', hover:false, focused:false, timer:0, abort:new AbortController() };
      states.set(root,state);
      const options = {signal:state.abort.signal};
      function schedule() {
        clearTimeout(state.timer);
        if (slides.length < 2 || state.paused || state.hover || state.focused || document.hidden || !root.isConnected) return;
        state.timer = setTimeout(() => show(state.index + 1, false), Math.max(3000,Number(root.dataset.interval)||5000));
      }
      function show(index,announce) {
        state.index = (index + slides.length) % slides.length;
        slides.forEach((slide,i) => slide.hidden = i !== state.index);
        if (count) count.textContent = `${state.index+1} / ${slides.length}`;
        if (announce && status) status.textContent = `Review ${state.index+1} of ${slides.length}`;
        schedule();
      }
      function updatePause() { if (pause) {pause.textContent=state.paused ? 'Play reviews' : 'Pause reviews';pause.setAttribute('aria-pressed',String(state.paused));} schedule(); }
      root.querySelector('[data-kp-prev]')?.addEventListener('click',() => show(state.index-1,true),options);
      root.querySelector('[data-kp-next]')?.addEventListener('click',() => show(state.index+1,true),options);
      pause?.addEventListener('click',() => {state.paused=!state.paused;updatePause();},options);
      root.addEventListener('mouseenter',() => {state.hover=true;schedule();},options);
      root.addEventListener('mouseleave',() => {state.hover=false;schedule();},options);
      root.addEventListener('focusin',() => {state.focused=true;schedule();},options);
      root.addEventListener('focusout',() => {queueMicrotask(() => {state.focused=root.contains(document.activeElement);schedule();});},options);
      document.addEventListener('visibilitychange',schedule,options);
      reduced.addEventListener('change',() => {if(reduced.matches){state.paused=true;updatePause();}},options);
      root.addEventListener('shopify:block:select',event => {const index=slides.findIndex(slide => slide===event.target || slide.contains(event.target));if(index>=0){state.paused=true;show(index,false);updatePause();}},options);
      updatePause();
    });
  }
  window.KiiveRefreshReviews={init};
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => {for(const root of states.keys())if(event.target.contains(root))destroy(root);});
  init(document);
})();
